import React from 'react'

const PanelSpace=props=>{
    return (
        <div className="col-sm">
            <div style={{paddingTop: '5px',paddingBottom: '5px'}}></div>
        </div>
    )
}

export default PanelSpace


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/common/PanelSpace.js